import React from 'react';

import Icon from '../../../../ui/icon/icon';
import useTranslate from '../../../../../common/hooks/useTranslate';

import './headerCell.scss';

const HeaderCell = (props) => {
  let headerCellStyles;

  const { t } = useTranslate();

  if (props.multipleDownload) {
    headerCellStyles = 'k-link download-padding';
  } else if (props.field === 'fileType') {
    headerCellStyles = 'k-link align-center';
  } else {
    headerCellStyles = 'k-link';
  }

  return (
    <div className={headerCellStyles} onClick={props.onClick}>
      {props.multipleDownload && (
        <div className="multiple-download" onClick={props.onDownloadClick}>
          <Icon className="actions-header-cell-icon" name="fas fa-file-zipper" />
          <span className="title">{t('DOCUMENTS_TABLE.COLUMN_DOWNLOAD')}</span>
        </div>
      )}
      {!props.multipleDownload && <span>{props.title}</span>}
      {props.children}
    </div>
  );
};

export default HeaderCell;
